import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const tickerItems = [
  'Past papers',
  'Quizzes',
  'Lab tasks',
  'Outlines',
  'CUI Lahore',
  'Free forever',
];

const titleWords = 'All your academic resources in one place'.split(' ');

const LandingPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = 'SitsCom — COMSATS Lahore Resources';
  }, []);

  const tickerLoop = [...tickerItems, ...tickerItems, ...tickerItems];

  return (
    <div className="landing">
      <div className="landing-bg">
        <div className="landing-gradient" />
        <div className="landing-grid" />
        <div className="landing-dots" />
        <div className="landing-orb landing-orb-1" />
        <div className="landing-orb landing-orb-2" />
        <div className="landing-orb landing-orb-3" />
      </div>

      <div className="landing-badge">
        <span className="badge-dot" />
        Open source student platform
      </div>

      <h1 className="landing-title">
        {titleWords.map((word) => (
          <span key={word} className="landing-title-word">{word}</span>
        ))}
      </h1>

      <p className="landing-subtitle">
        Past papers, course materials, assignments, books, and quizzes for
        COMSATS Lahore — curated by students, for students.
      </p>

      <div className="landing-actions">
        <button className="btn btn-primary btn-lg" onClick={() => navigate('/home')}>
          Find subjects
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
            <path d="M5 12h14M12 5l7 7-7 7" />
          </svg>
        </button>
        <button className="btn btn-secondary btn-lg" onClick={() => navigate('/about')}>
          Learn more
        </button>
      </div>

      <div className="landing-ticker">
        <div className="ticker-track">
          <div className="ticker-content">
            {tickerLoop.map((item, i) => (
              <span key={i} className="ticker-item">
                {item}
                <span className="ticker-sep" />
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
